// extracted by mini-css-extract-plugin
module.exports = {"grid":"Feed-module--grid--1oSfd","h2":"Feed-module--h2--3R9NT","story":"Feed-module--story--_OKLb"};